import SahamDialog from 'components/SahamDialog';
import { translate } from 'containers/services/translate';
import { MouseEventHandler } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/CourtManagerLegalProceedings/messages';

export interface AlertInformationDialogProps {
  intl: IntlShape;
  open: boolean;
  setShowAlertInformation: Function;
  history: any;
  targetLocation: any;
}
export const AlertInfortionDialog: React.FC<AlertInformationDialogProps> = (
  props,
): JSX.Element => {
  const handleValidate = () => {
    props.setShowAlertInformation(false);
    return props.history.push(props.targetLocation);
  };
  const handleClose = () => {
    props.setShowAlertInformation(false);
  };
  return (
    <SahamDialog
      handleValidate={handleValidate}
      handleClose={handleClose as MouseEventHandler}
      title={translate(messages.alertTitle, props)}
      cancelTitle={translate(
        messages.courtManagerConfirmationDialogCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerConfirmationDialogConfirm,
        props,
      )}
      open={props.open}
    >
      <span>{translate(messages.alertQuitContent, props)}</span>
    </SahamDialog>
  );
};
export default injectIntl(AlertInfortionDialog);
